import { Navigate, Outlet } from 'react-router-dom';

interface ProtectedRouteProps {
    isAllowed: boolean;
    redirectTo: string;
}

const ProtectedRoute = (props: ProtectedRouteProps) => {
  if (!props.isAllowed) {
    return <Navigate to={props.redirectTo} replace />;
  }
  return <Outlet />;
};

export default ProtectedRoute;